import Vue from 'vue';
import merge from 'lodash/merge';

/**
 * AuthLogsService
 */
class AuthLogsService
{
    static async getAuthLog(filter, pager)
    {
        return Vue.axios.get('admin/authlogs/getlist', {
            params: merge({}, filter, pager.data())
        });
    }
}

export default AuthLogsService;
